<script>
import api from '../../Api/address'

export default {
    props: {
        address: {
            type: Object,
            required: true
        }
    },

    methods: {
        async remove() {
            try {
                await api.delete(this.address)

                this.$bus.$emit('address-deleted', this.address)
            }
            catch (error) {
                this.$bus.$emit('address-error', error)
            }
        }
    },

    render() {
        return this.$scopedSlots.default({
            remove: this.remove
        })
    }
}
</script>
